export default "__VITE_ASSET__W4kEqYY2__"